import { createFileRoute } from '@tanstack/react-router';
import { Schema } from 'effect';
import { ConnectConsentPage } from '@/components/web-fe/features/connect-app/connect-consent-page';

const ConnectConsentSearch = Schema.Struct({ oauth_query: Schema.String });

export const Route = createFileRoute('/app/connect/consent')({
  validateSearch: Schema.toStandardSchemaV1(ConnectConsentSearch),
  head: () => ({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] }),
  component: Page,
});

function Page() {
  return <ConnectConsentPage oauthQuery={Route.useSearch().oauth_query} />;
}
